import * as React from 'react';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';

import css from './loader.css';


export const Loader = () => {
  return <CircularLoader className={css.loader} />;
};
